/* MyBeet buy box: galeria, pakiety, gratisy, dodawanie do koszyka. */
(function () {
  'use strict';

  // Wlasny formatter - nie polegamy na money_format sklepu.
  // Konwencja PL: spacja tysiecy, przecinek dziesietnych, "zl" po liczbie.
  function pln(v) {
    var s = (Math.round(v * 100) / 100).toFixed(2).replace('.', ',');
    var parts = s.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    return parts.join(',') + ' zł';
  }

  // Cale zwroty z przyimkiem, bo polski wymaga tu biernika, a wtorek dodatkowo
  // przyimka "we" (zbieg spolglosek): w poniedzialek, WE wtorek, w srode.
  var DAYS = ['w niedzielę', 'w poniedziałek', 'we wtorek', 'w środę',
              'w czwartek', 'w piątek', 'w sobotę'];
  var MONTHS = ['stycznia', 'lutego', 'marca', 'kwietnia', 'maja', 'czerwca',
                'lipca', 'sierpnia', 'września', 'października', 'listopada', 'grudnia'];

  // Termin dostawy liczymy w dniach doreczenia, nie w dniach roboczych:
  // kurierzy dowoza takze w soboty, wiec z liczenia wypada wylacznie niedziela.
  // Przy starym liczeniu (pomijalo tez sobote) zamowienie z czwartku pokazywalo
  // poniedzialek, choc paczka realnie szla w sobote.
  function deliveryDate(minDays) {
    var d = new Date();
    var added = 0;
    while (added < minDays) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() !== 0) added++;   // 0 = niedziela
    }
    return DAYS[d.getDay()] + ', ' + d.getDate() + ' ' + MONTHS[d.getMonth()];
  }

  function initGallery(root) {
    var slides = root.querySelector('[data-mb-slides]');
    if (!slides) return;
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mb-thumb]'));
    var count = slides.children.length;
    if (!count) return;

    function activeIdx() { return Math.round(slides.scrollLeft / slides.clientWidth); }
    function mark(i) {
      thumbs.forEach(function (t, n) { t.classList.toggle('is-active', n === i); });
    }
    function goTo(i) {
      var idx = (i + count) % count; // strzalki zapetlaja sie
      slides.scrollTo({ left: idx * slides.clientWidth, behavior: 'smooth' });
      mark(idx);
    }

    // Kropki i miniatury synchronizuja sie przy KAZDYM sposobie przewiniecia,
    // nie tylko po kliknieciu - stad listener na scroll z debounce.
    var t = null;
    slides.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () { mark(activeIdx()); }, 60);
    });
    thumbs.forEach(function (btn, i) {
      btn.addEventListener('click', function () { goTo(i); });
    });
    root.querySelectorAll('[data-mb-arrow]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goTo(activeIdx() + parseInt(btn.getAttribute('data-mb-arrow'), 10));
      });
    });

    // Drag mysza tylko dla pointerType mouse - dotyk ma natywny scroll.
    var down = false, startX = 0, startLeft = 0, moved = false;
    slides.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = slides.scrollLeft;
      slides.classList.add('is-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      slides.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      slides.classList.remove('is-dragging');
      if (moved) {
        // dosnapowanie do najblizszego slajdu po zakonczeniu dragu
        setTimeout(function () { goTo(activeIdx()); }, 30);
      }
    });
    slides.addEventListener('dragstart', function (e) { e.preventDefault(); });
    mark(0);
  }

  function initBuybox(root) {
    var dataEl = root.querySelector('[data-mb-config]');
    if (!dataEl) return;
    var cfg = JSON.parse(dataEl.textContent);

    var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-mb-tier]'));
    var gifts = Array.prototype.slice.call(root.querySelectorAll('[data-mb-gift]'));
    var giftFill = root.querySelector('[data-mb-gift-fill]');
    var giftCount = root.querySelector('[data-mb-gift-count]');
    var atc = root.querySelector('[data-mb-atc]');
    var selected = -1;

    function render(i) {
      selected = i;
      tiers.forEach(function (el, n) {
        el.classList.toggle('is-selected', n === i);
        var input = el.querySelector('input');
        if (input) input.checked = (n === i);
      });
      var level = i < 0 ? 0 : (cfg.tiers[i].unlock || 0);
      var open = 0;
      gifts.forEach(function (g) {
        var need = parseInt(g.getAttribute('data-mb-gift'), 10);
        var isOpen = level >= need;
        g.classList.toggle('is-open', isOpen);
        if (isOpen) open++;
      });
      if (giftFill) giftFill.style.width = (gifts.length ? (open / gifts.length) * 100 : 0) + '%';
      if (giftCount) giftCount.textContent = open + '/' + gifts.length;
    }

    tiers.forEach(function (el, i) {
      el.addEventListener('click', function () {
        render(i);
        window.__mbLastAtc = atc;
      });
    });

    var dd = root.querySelector('[data-mb-deliver]');
    if (dd) dd.textContent = deliveryDate(parseInt(dd.getAttribute('data-mb-deliver'), 10) || 2);

    function items() {
      var t = cfg.tiers[selected];
      var out = [{ id: cfg.variantId, quantity: t.qty }];
      var level = t.unlock || 0;
      if (cfg.giftEbook && level >= 1) out.push({ id: cfg.giftEbook, quantity: 1 });
      if (cfg.giftMystery && level >= 2) out.push({ id: cfg.giftMystery, quantity: 1 });
      // Ubezpieczenie leci w TYM SAMYM zadaniu co produkt. Dokladane osobno po
      // odswiezeniu drawera pojawialo sie dopiero w checkoucie, bo klient widzial
      // panel przed druga runda zapytan.
      if (cfg.insurance && localStorage.getItem('mb-insurance') !== 'off') {
        out.push({ id: cfg.insurance, quantity: 1 });
      }
      // Shopify uklada koszyk od najnowszej pozycji, wiec to, co wyslemy jako
      // ostatnie, wyswietli sie na gorze. Tablice budujemy w kolejnosci
      // docelowej (produkt, gratisy, ubezpieczenie) i odwracamy przed wyslaniem.
      return out.reverse();
    }

    function refreshDrawer(sections) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !sections) { window.location.href = window.Shopify.routes.root + 'cart'; return; }
      drawer.classList.remove('is-empty');
      var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = parsed.querySelector('#CartDrawer');
      var target = document.querySelector('#CartDrawer');
      if (fresh && target) target.replaceWith(fresh);
      var bubbleDoc = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
      var bubbleSrc = bubbleDoc.querySelector('.shopify-section');
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubbleSrc && bubble) bubble.innerHTML = bubbleSrc.innerHTML;
      if (typeof drawer.open === 'function') drawer.open();
      else drawer.classList.add('active', 'animate');
      document.dispatchEvent(new CustomEvent('mb:cart:updated'));
    }

    atc.addEventListener('click', function () {
      if (selected < 0) {
        // Klikniecie bez wyboru nie moze byc cisza - shake i doscroll.
        var wrap = root.querySelector('[data-mb-tiers]');
        wrap.classList.remove('mb-nudge');
        void wrap.offsetWidth;
        wrap.classList.add('mb-nudge');
        wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      atc.classList.add('is-loading');
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items(), sections: 'cart-drawer,cart-icon-bubble' })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          atc.classList.remove('is-loading');
          refreshDrawer(d.sections);
        })
        .catch(function () {
          atc.classList.remove('is-loading');
          window.location.href = window.Shopify.routes.root + 'cart';
        });
    });

    render(typeof cfg.preselect === 'number' ? cfg.preselect : 1);
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-mb-acc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.mb-acc__item').classList.toggle('is-open');
      });
    });
  }

  // Gratisy na dol koszyka. Shopify ustala kolejnosc pozycji w momencie
  // dodania, wiec koszyk zlozony przed poprawka kolejnosci nadal mialby
  // gratisy na gorze. Tu przestawiamy same wiersze w DOM - indeksy linii
  // siedza w atrybutach data-index, wiec zmiana ilosci dalej trafia w swoja
  // pozycje. Nie ruszamy tabeli po stronie serwera.
  function darmowyWiersz(row) {
    var txt = '';
    row.querySelectorAll('.cart-item__price-wrapper, .cart-item__totals, .cart-item__final-price, [class*="price"]')
      .forEach(function (e) { txt += ' ' + e.textContent; });
    if (!txt.trim()) txt = row.textContent;
    // zero w dowolnym formacie: "0,00 zl", "0.00", "Gratis"
    return /(^|\s)0[.,]00(\s|\D|$)/.test(txt) && !/[1-9]\d*[.,]\d\d/.test(txt);
  }

  var przestawiam = false;

  function porzadkujKoszyk() {
    if (przestawiam) return;
    var wiersze = [].slice.call(document.querySelectorAll(
      '#CartDrawer .cart-item, .cart-items .cart-item, cart-drawer .cart-item'));
    if (wiersze.length < 2) return;
    var rodzic = wiersze[0].parentNode;
    var darmowe = wiersze.filter(darmowyWiersz);
    if (!darmowe.length || darmowe.length === wiersze.length) return;

    // KLUCZOWE: ruszamy DOM tylko wtedy, gdy kolejnosc faktycznie jest zla.
    // Bezwarunkowe appendChild generowalo zmiany, na ktore reagowal nasz
    // wlasny obserwator - i strona krecila sie w kolko.
    var ogon = wiersze.slice(wiersze.length - darmowe.length);
    var juzDobrze = true;
    for (var i = 0; i < ogon.length; i++) {
      if (!darmowyWiersz(ogon[i])) { juzDobrze = false; break; }
    }
    if (juzDobrze) return;

    przestawiam = true;
    darmowe.forEach(function (w) {
      if (w.parentNode === rodzic) rodzic.appendChild(w);
    });
    przestawiam = false;
  }

  function initPorzadekKoszyka() {
    if (window.__mbPorzadekReady) return;
    window.__mbPorzadekReady = true;
    porzadkujKoszyk();
    document.addEventListener('mb:cart:updated', function () { setTimeout(porzadkujKoszyk, 60); });

    // Obserwujemy WYLACZNIE szuflade koszyka. Wczesniej przy jej braku
    // obserwowalismy cale body, wiec kazda zmiana na stronie (leniwe obrazki,
    // aplikacje, sekcje) uruchamiala pelne skanowanie - stad zamulanie.
    var cel = document.querySelector('cart-drawer');
    if (!cel || !window.MutationObserver) return;
    var czeka = false;
    var mo = new MutationObserver(function () {
      if (przestawiam || czeka) return;
      czeka = true;
      // jedno przeliczenie na klatke zamiast na kazda mutacje
      requestAnimationFrame(function () { czeka = false; porzadkujKoszyk(); });
    });
    mo.observe(cel, { childList: true, subtree: true });
  }

  // Przyklejony pasek ATC. Wchodzi dopiero, gdy zaden zwykly przycisk
  // "Dodaj do koszyka" nie jest widoczny I jestesmy ponizej pierwszego z nich.
  // Dzieki temu nie miga przy wejsciu na strone ani po powrocie na gore.
  function initSticky() {
    var bary = [].slice.call(document.querySelectorAll('[data-mb-sticky]'));
    if (!bary.length) return;
    // dwie sekcje buy boxa = ryzyko dwoch paskow, zostawiamy pierwszy
    bary.slice(1).forEach(function (b) { b.remove(); });
    var bar = bary[0];
    if (bar.dataset.mbReady) return;
    bar.dataset.mbReady = '1';

    var przyciski = [].slice.call(document.querySelectorAll('[data-mb-atc]'));
    if (!przyciski.length) { bar.remove(); return; }
    var widoczne = [];

    function odswiez() {
      var pierwszy = przyciski[0].getBoundingClientRect();
      var ponizej = pierwszy.bottom < 0;
      var szuflada = document.querySelector('cart-drawer.active, cart-drawer.animate, cart-drawer[open]');
      var pokaz = ponizej && widoczne.length === 0 && !szuflada;
      bar.classList.toggle('is-on', pokaz);
      bar.setAttribute('aria-hidden', pokaz ? 'false' : 'true');
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (wpisy) {
        wpisy.forEach(function (w) {
          var i = widoczne.indexOf(w.target);
          if (w.isIntersecting && i < 0) widoczne.push(w.target);
          if (!w.isIntersecting && i >= 0) widoczne.splice(i, 1);
        });
        odswiez();
      }, { rootMargin: '0px 0px -10px 0px' });
      przyciski.forEach(function (b) { io.observe(b); });
    }
    window.addEventListener('scroll', odswiez, { passive: true });
    window.addEventListener('resize', odswiez);
    document.addEventListener('mb:cart:updated', function () { setTimeout(odswiez, 60); });
    odswiez();

    var btn = bar.querySelector('[data-mb-sticky-atc]');
    if (btn) {
      btn.addEventListener('click', function () {
        // klikamy przycisk tej sekcji, w ktorej klient ostatnio wybieral pakiet,
        // zeby pasek nie dodal innego wariantu niz ten zaznaczony na ekranie
        var cel = window.__mbLastAtc && document.contains(window.__mbLastAtc)
          ? window.__mbLastAtc : przyciski[0];
        btn.classList.add('is-loading');
        cel.click();
        setTimeout(function () { btn.classList.remove('is-loading'); }, 1200);
      });
    }
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-mb-buybox]').forEach(function (root) {
      if (root.dataset.mbReady) return;
      root.dataset.mbReady = '1';
      initGallery(root);
      initBuybox(root);
      initAccordions(root);
    });
    initSticky();
    initPorzadekKoszyka();
  }

  document.addEventListener('DOMContentLoaded', function () { boot(document); });
  if (document.readyState !== 'loading') boot(document);
  // edytor motywu przeladowuje pojedyncze sekcje
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
